/** Linha do índice (01 §6.2 GET /menu/indice). */
export interface ItemIndice {
  codigo: string;
  nome: string;
  modulo: string;
  moduloNome: string;
  caminho: string;
  palavras: string[];
  icone?: string | null;
  tipo: string;
  podeIncluir: boolean;
}

export function semAcento(s: string): string {
  return s.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
}

/** Todas as letras de `agulha` aparecem em ordem em `palheiro`. */
function subsequencia(agulha: string, palheiro: string): boolean {
  let i = 0;
  for (const c of palheiro) if (c === agulha[i]) i++;
  return i === agulha.length;
}

/**
 * Pontuação do 07 §2.5: código exato 1000 > prefixo do código 800 > prefixo de palavra 500 > subsequência 100;
 * +50 se favorito; +recência (0–40). "ped ven" acha "Pedido de Venda"; "010" acha "FAT010".
 */
export function pontuar(item: Pick<ItemIndice, 'codigo' | 'nome' | 'palavras'>, consulta: string, favorito = false, recencia = 0): number {
  const q = semAcento(consulta.trim());
  if (!q) return 0;
  const codigo = item.codigo.toLowerCase();
  const nome = semAcento(item.nome);
  const palavras = [...nome.split(/[^a-z0-9]+/), ...item.palavras.map(semAcento)].filter(Boolean);
  const termos = q.split(/\s+/);
  let base = 0;
  if (codigo === q) base = 1000;
  else if (codigo.startsWith(q) || codigo.slice(3) === q || codigo.slice(3).startsWith(q)) base = 800;
  else if (termos.every((t) => palavras.some((p) => p.startsWith(t)))) base = 500;
  else if (subsequencia(q.replace(/\s+/g, ''), nome.replace(/\s+/g, '')) || subsequencia(q, codigo)) base = 100;
  if (base === 0) return 0;
  return base + (favorito ? 50 : 0) + Math.max(0, Math.min(40, recencia));
}

export function buscar<T extends Pick<ItemIndice, 'codigo' | 'nome' | 'palavras'>>(itens: T[], consulta: string, favoritos: string[] = [], recentes: string[] = [], limite = 30): T[] {
  const fav = new Set(favoritos);
  return itens
    .map((i) => {
      const r = recentes.indexOf(i.codigo);
      return { i, p: pontuar(i, consulta, fav.has(i.codigo), r < 0 ? 0 : 40 - r * 2) };
    })
    .filter((x) => x.p > 0)
    .sort((a, b) => b.p - a.p || a.i.codigo.localeCompare(b.i.codigo))
    .slice(0, limite)
    .map((x) => x.i);
}
